import { jsonldLongitude } from './JsonldStore';

export const updateJsonldLongitude = (value) => jsonldLongitude.update((oldValue) => value);
